// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__19FHu","paramInput":"JobSimulator_paramInput__1wfg4","input":"JobSimulator_input__2eYfZ"};